import { Button, Modal, Text } from "@mantine/core";
import { ModalFooter } from "../../../../../../mantine/components/ModalFooter/ModalFooter";
import type { Price } from "../../../../DeliveryOverview.types";
import type { ChangeableSpotMarketFormula } from "../../../DeliveryModal/DeliveryForm/CustomFields/ChangeableSpotMarketField/ChangeableSpotMarketFormulaFieldStatic/ChangeableSpotMarketFormulaFieldStatic";

type FuturePriceWarningModalProps<
  T extends Price | ChangeableSpotMarketFormula
> = {
  onSuccess: (prices: Array<T>) => Promise<void>;
  onCancel: () => void;
  prices: Array<T>;
};

function FuturePriceWarningModal<
  T extends Price | ChangeableSpotMarketFormula
>({ onSuccess, onCancel, prices }: FuturePriceWarningModalProps<T>) {
  return (
    <Modal
      opened
      size="lg"
      title="Kurzfristige Änderung bestätigen"
      onClose={onCancel}
    >
      <Text>
        Gemäß § 41 Abs. 5 Satz 2 EnWG sind Haushaltskunden spätestens einen
        Monat vor Eintritt der beabsichtigten Änderung zu unterrichten. Für
        andere Letztverbraucher gilt eine Frist von 2 Wochen. Sind Sie sicher,
        dass Sie die Preisänderung durchführen möchten?
      </Text>
      <ModalFooter>
        <Button variant="default" onClick={onCancel}>
          Abbrechen
        </Button>
        <Button color="warning" onClick={() => onSuccess(prices)}>
          Preisänderung bestätigen
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { FuturePriceWarningModal, FuturePriceWarningModalProps };
